import React, { useMemo } from 'react';

import FormAutocomplete from 'components/FormFields/FormAutocomplete';

export const CONTACT_FIELD_LABEL_INFO = {
  address: [
    {
      id: 'home',
      label: 'Home',
      vcard: ['HOME'],
    },
    {
      id: 'work',
      label: 'Work',
      vcard: ['WORK'],
    },
    {
      id: 'other',
      label: 'Other',
      vcard: ['OTHER'],
    },
    {
      id: 'custom',
      label: 'Custom...',
      custom: true,
    },
  ],
  email: [
    {
      id: 'home',
      label: 'Home',
      vcard: ['HOME'],
    },
    {
      id: 'work',
      label: 'Work',
      vcard: ['WORK'],
    },
    {
      id: 'other',
      label: 'Other',
      apple: '_$!<Other>!$_',
    },
    {
      id: 'custom',
      label: 'Custom...',
      custom: true,
    },
  ],
  phone: [
    {
      id: 'cell',
      label: 'Cell',
      vcard: ['CELL', 'VOICE'],
    },
    {
      id: 'iphone',
      label: 'iPhone',
      vcard: ['IPHONE', 'CELL', 'VOICE'],
    },
    {
      id: 'home',
      label: 'Home',
      vcard: ['HOME', 'VOICE'],
    },
    {
      id: 'work',
      label: 'Work',
      vcard: ['WORK', 'VOICE'],
    },
    {
      id: 'main',
      label: 'Main',
      vcard: ['MAIN'],
    },
    {
      id: 'homefax',
      label: 'Home Fax',
      vcard: ['HOME', 'FAX'],
    },
    {
      id: 'workfax',
      label: 'Work Fax',
      vcard: ['WORK', 'FAX'],
    },
    {
      id: 'fax',
      label: 'Fax',
      vcard: ['OTHER', 'FAX'],
    },
    {
      id: 'pager',
      label: 'Pager',
      vcard: ['PAGER'],
    },
    {
      id: 'other',
      label: 'Other',
      vcard: ['OTHER', 'VOICE'],
    },
    {
      id: 'custom',
      label: 'Custom...',
      custom: true,
    },
  ],
  website: [
    {
      id: 'homepage',
      label: 'Home Page',
      apple: '_$!<HomePage>!$_',
    },
    {
      id: 'home',
      label: 'Home',
      vcard: ['HOME'],
    },
    {
      id: 'work',
      label: 'Work',
      vcard: ['WORK'],
    },
    {
      id: 'other',
      label: 'Other',
      apple: '_$!<Other>!$_',
    },
    {
      id: 'custom',
      label: 'Custom...',
      custom: true,
    },
  ],
};

const ContactFieldType = ({
  value,
  onChange,
  type,
  placeholder,
}) => {
  const options = useMemo(() => {
    return CONTACT_FIELD_LABEL_INFO[type].filter(opt => !opt.custom);
  }, [type]);
  const ids = useMemo(() => options.map(opt => opt.id), [options]);
  const selectedValue = useMemo(() => {
    const found = CONTACT_FIELD_LABEL_INFO[type].find(info => info.id === value);
    if (found) {
      return found.label;
    }
    return value;
  }, [value]);

  const handleChange = (_value) => {
    if (_value === '') return;
    const _type = _value.toLowerCase();
    if (ids.includes(_type)) {
      onChange({ contactType: _type, fieldLabel: null });
    } else {
      onChange({ contactType: 'custom', fieldLabel: _value });
    }
  };

  const renderOption = ({ id, label }) => (
    <button
      key={`contact-type-${id}`}
      selected={value === id}
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => handleChange(id)}
      className="button--unstyled autocomplete__option"
    >
      {label}
    </button>
  );

  if (!type) return;

  return (
    <FormAutocomplete
      id={`update-contact-type-${type}`}
      name="Contact type"
      labelHidden
      onSubmit={handleChange}
      value={selectedValue ?? ''}
      options={options}
      renderOption={renderOption}
      placeholder={placeholder}
      submitOnBlur
    />
  );
};

export default ContactFieldType;
